import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetActivePatientProtocolsWithTreatments(patientId: string | undefined) {
  return useQuery(queries.patients.getActivePatientProtocolsWithTreatments(patientId || ''))
}
